module.exports = __webpack_public_path__ + "files/4f155a3251780c8ad33f4ab49109f252.png";